var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-table",
    _vm._l(_vm.members, function(member, index) {
      return _c(
        "md-table-row",
        { key: member + index },
        [
          _c(
            "md-table-cell",
            [
              _vm.selected.indexOf(member._id) < 0
                ? _c("font-awesome-icon", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.admin
                          ? _vm.selected.length < 30 - _vm.admin.length
                            ? true
                            : false
                          : true,
                        expression:
                          "admin ? selected.length < 30 - admin.length ? true : false : true"
                      }
                    ],
                    staticClass: "selector",
                    attrs: { icon: "square" },
                    on: {
                      click: function($event) {
                        return _vm.toggle(member)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.selected.indexOf(member._id) >= 0
                ? _c("font-awesome-icon", {
                    staticClass: "selector",
                    attrs: { icon: "check-square" },
                    on: {
                      click: function($event) {
                        return _vm.toggle(member)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("md-table-cell", { staticClass: "capitalize" }, [
            _c(
              "span",
              {
                staticClass: "display-link",
                on: {
                  click: function($event) {
                    return _vm.goToProfile(member)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.displayName(member)))]
            )
          ]),
          _vm._v(" "),
          _c("md-table-cell", [_vm._v(_vm._s(member.emails[0]))])
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a77d1be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a77d1be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultiMemberPicker.vue
// module id = null
// module chunks = 